import constantStrings from "./constantStrings"
// English Constant Strings Which are used in Chat Widget UI
export default {
  [constantStrings.CHAT_ENDED]: 'Chat Ended',
  [constantStrings.SESSION_HAS_EXPIRED]: 'Session has expired',
  [constantStrings.BACK]: 'Back',
  [constantStrings.RESTART]: 'Restart',
  [constantStrings.SKIP]: 'Skip',
  [constantStrings.USER_LAST_MESSAGE_STATUS]: ' . Seen',
  [constantStrings.INCORRECT_INPUT_VALUE]: 'Incorrect input value',
  [constantStrings.INVALID_VALIDATION]: 'Invalid validation.',
  [constantStrings.QUICK_MENU]: 'Quick Menu',
  [constantStrings.END_CHAT]:'End chat',
  [constantStrings.SOUND]: 'Sound',
  [constantStrings.INPUT_PLACEHOLDER]: 'Type your message..',
  [constantStrings.OFFLINE_BANNER_TEXT]: 'No Internet Connection',
  [constantStrings.OFFLINE_MESSAGE_ERROR] : 'Not Sent',
  [constantStrings.CHAT_RESTART]: 'Chat Restarted'
}